export type PlugLedUiMode = 'power' | 'switch' | 'off' | 'color';

export type PlugLedApiMode = 'power' | 'switch' | 'off';

export function rgbUiToDevice(rgb: number[]): number[] {
	return rgb.map((c) => Math.round(c / 2.55));
}

export function apiLedMode(selectedMode: string): PlugLedApiMode {
	if (selectedMode === 'color' || selectedMode === 'switch') return 'switch';
	if (selectedMode === 'power') return 'power';
	return 'off';
}

export function buildLedsColors(params: {
	selectedMode: string;
	structure: string;
	hasRelay: boolean;
	powerBrightness: number;
	colorOn: number[] | undefined;
	brightnessOn: number;
	colorOff: number[] | undefined | null;
	brightnessOff: number | undefined | null;
}): Record<string, unknown> {
	const mode = apiLedMode(params.selectedMode);
	if (mode === 'power') {
		return {
			power: {
				brightness: params.powerBrightness,
			},
		};
	}
	if (mode === 'switch' && Array.isArray(params.colorOn)) {
		return {
			[params.structure]: {
				on: {
					rgb: rgbUiToDevice(params.colorOn),
					brightness: Number(params.brightnessOn),
				},
				off:
					params.hasRelay && Array.isArray(params.colorOff)
						? {
								rgb: rgbUiToDevice(params.colorOff),
								brightness: Number(params.brightnessOff),
							}
						: null,
			},
		};
	}
	return {};
}

export function buildPlugUiLedsConfig(params: {
	selectedMode: string;
	structure: string;
	hasRelay: boolean;
	powerBrightness: number;
	colorOn: number[] | undefined;
	brightnessOn: number;
	colorOff: number[] | undefined | null;
	brightnessOff: number | undefined | null;
	nightEnable: boolean;
	nightStart: string;
	nightEnd: string;
	nightBrightness: number;
}): { leds: Record<string, unknown> } {
	return {
		leds: {
			mode: apiLedMode(params.selectedMode),
			colors: buildLedsColors(params),
			night_mode: {
				enable: params.nightEnable,
				active_between: [params.nightStart, params.nightEnd],
				brightness: params.nightBrightness,
			},
		},
	};
}
